import dayjs from "dayjs";

export const formatDateRange = (start, end) => {
  if (!start) return "";
  const a = dayjs(start);
  const b = end ? dayjs(end) : null;
  if (!b || b.isSame(a, "day")) return a.format("MMM D, YYYY");
  if (a.isSame(b, "month")) return `${a.format("MMM D")}-${b.format("D, YYYY")}`;
  if (a.isSame(b, "year")) return `${a.format("MMM D")} – ${b.format("MMM D, YYYY")}`;
  return `${a.format("MMM D, YYYY")} – ${b.format("MMM D, YYYY")}`;
};

export const joinStyles = (styles = []) => styles.join("  •  ");

export const money = (amount, currency = "usd") =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: (currency || "usd").toUpperCase() }).format(amount || 0);
